import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FechamentoService } from 'app/services/fechamento.service';

@Component({
  selector: 'app-clientes-fechamento',
  templateUrl: './clientes-fechamento.component.html',
  styleUrls: ['./clientes-fechamento.component.scss']
})
export class ClientesFechamentoComponent implements OnInit {
  contentHeader: object;
  rows: Array<any> | any = [];
  temp: Array<any> | any = [];
  href: any;
  routeLink: any;
  idFechamento: any;
  idCliente: any;

  constructor(private route: ActivatedRoute, private fechamentoService: FechamentoService) { }

  ngOnInit(): void {
    this.href = this.route.url;
    this.routeLink = this.href.value[0].path
    this.idFechamento = this.href.value[1].path

    this.contentHeader = {
      headerTitle: "Detalhamento Final",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Início",
            isLink: false,
          },
          {
            name: "fechamento",
            isLink: false,
          },
          {
            name: "detalhamento final",
            isLink: false,
          },
        ],
      },
    };
    
    this.fechamentoService.getFechamentoClientes(this.idFechamento).subscribe(
      (res) => {
        if (res.data.length > 0 && res.statusCode == 201) {
          
          (this.rows = res.data[0]), (this.temp = res.data[0]), (this.temp = this.rows);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

	textFilterVeiculo(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d[param] != null) return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

}
